import { FC } from "react";
import styles from "../Scam.module.scss";

const Alert: FC = () => (
    <div className={styles.alert}>
        Always check and analyze information about the project, our analysis only informs, always carry out DYOR
    </div>
);

export default Alert;
